import { UncontrolledTooltip } from "reactstrap";
import { SOCIAL_GROUP_DATA } from "../../../../../Data/SocialApp";
import { Image, LI, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";

const SocialGroup = () => {
  return (
    <UL className="justify-content-center simple-list d-flex flex-row">
      {SOCIAL_GROUP_DATA.map((data, index) => (
        <LI className="d-inline-block" key={index}>
          <Image className="img-40 rounded-circle" src={dynamicImage(`user/${data.imageName}`)} alt="Img" id={`UncontrolledTooltipExample-${index}`}/>
          <UncontrolledTooltip placement="top" target={`UncontrolledTooltipExample-${index}`}>
            {data.userName}
          </UncontrolledTooltip>
        </LI>
      ))}
    </UL>
  );
};

export default SocialGroup;
